import React from 'react';
import PropTypes from 'prop-types';
import withI18next from '~/../hocs/_withI18next';
import { urls } from '~/utils';

@withI18next()
class Avatar extends React.PureComponent {
  render() {
    const { src, size, random } = this.props;
    return (
      <div className="ac-avatar" style={{ width: size, height: size }}>
        <img
          src={urls.renderAvatarUrl(src, random)}
          className="img-responsive"
        />
        <style jsx>
          {`
            .ac-avatar {
              display: inline-block;
            }
            .ac-avatar .img-responsive {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              border: 1px solid rgba(0, 0, 0, 0.1);
            }
          `}
        </style>
      </div>
    );
  }
}

Avatar.propTypes = {
  url: PropTypes.string,
  size: PropTypes.number,
};
Avatar.defaultProps = {
  url: '',
  size: 100,
};
export default Avatar;
